import { INPUT_FIELD_FORMATTERS } from '../(ui)/ui-lib/InputFieldFormatters';

/**
 * Common formatting utilities used throughout the application
 */

/**
 * Format a currency amount with no decimal places
 */
export const formatCurrency = (amount: number): string => {
  return INPUT_FIELD_FORMATTERS.currency.format(amount);
};

/**
 * Format a date in a consistent format
 * @param dateString The date string to format
 * @param includeTime Whether to include the time in the output (defaults to false)
 * @returns Formatted date string (MM DD, YYYY) or (MM DD, YYYY, HH:MM:SS) if includeTime is true
 */
export const formatDate = (dateString?: string, includeTime: boolean = false): string => {
  if (!dateString) return '-';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '-';
  
  if (includeTime) {
    return d.toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit'
    });
  }
  
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
};

export function getSigningDateBusinessDayThreshold(propertyType?: string | { display?: string }): number {
  const name = (typeof propertyType === 'string' ? propertyType : propertyType?.display || '').toLowerCase();
  if (name.includes('single family')) return 10;
  if (name.includes('condo')) return 15;
  if (name.includes('multi-family')) return 20;
  return 10;
}

export function getEarliestSigningDate(propertyType?: string | { display?: string }): string {
  const businessDays = getSigningDateBusinessDayThreshold(propertyType);
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  let added = 0;
  while (added < businessDays) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) added++;
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a person's name consistently by concatenating first and last names
 */
export const formatName = (first?: string, last?: string): string | undefined => {
  const fullName = [first?.trim(), last?.trim()].filter(Boolean).join(' ');
  return fullName || undefined;
};